import { Injectable } from '@angular/core';
import { UserService } from 'app/core/user/user.service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

export type categories =
  | 'Interactivity'
  | 'Search'
  | 'Viewer Interactivity'
  | 'Authentication'
  | 'Navigation'
  | 'Errors';

@Injectable({
  providedIn: 'root',
})
export class GAnalyticsService {
  constructor(
    private $gaService: GoogleAnalyticsService,
    private userService: UserService,
  ) {}

  async setEvent(action: string, category: categories, user?: string) {
    try {
      const user = await this.userService.getCurrentUser();
      this.$gaService.event(action, category, user.client + ':' + user.email);
    } catch (error) {
      this.$gaService.event(action, category, user ? user : 'Guest');
    }
  }
}
